import { useEffect, useRef, useState } from 'react';
import { fetchReportingAvailability } from './api';
import { AvailabilityState } from './types';

const initialState: AvailabilityState = {
  status: 'idle',
  clients: [],
  projects: [],
};

// username: the owner of the timesheet being viewed; undefined reads the
// signed-in account.
export const useReportingAvailability = (
  date?: string,
  enabled = true,
  username?: string,
): AvailabilityState => {
  const [state, setState] = useState(initialState);
  const request = useRef(0);

  useEffect(() => {
    const requestId = ++request.current;
    if (!date || !enabled) {
      setState(initialState);
      return;
    }

    setState({ ...initialState, status: 'loading' });

    fetchReportingAvailability(date, username)
      .then((availability) => {
        if (request.current !== requestId) {
          return;
        }
        setState(availability);
      })
      .catch((error) => {
        if (
          (error as Error).name !== 'AbortError' &&
          request.current === requestId
        ) {
          setState({ ...initialState, status: 'error' });
        }
      });
  }, [date, enabled, username]);

  return state;
};
